import styled from 'styled-components';

const DayRangeWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  flex-wrap: wrap;
  @media all and (max-width: 576px) {
    justify-content: center;
  }
`;

const DayRangeButton = styled.div`
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  width: 50px;
  transition: opacity 0.25s ease-in-out;
  box-sizing: border-box;
  font-size: 16px; 
  span {
    display: block;
    width: 100%;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;  
  }
  color: ${p => p.disabled ? p.theme.color.label : p.theme.color.text};
  background-color: ${(p) => {
    if (p.disabled) {
      return p.theme.color.border;
    } else if (p.active) {
      return p.theme.color.bg_switcher;
    } else {
      return 'transparent';
    }
  }};
  ${p => p.disabled ? 'pointer-events: none' :
    `&:hover {
        opacity: 0.8;
        cursor: pointer;
      }
  `}

  @media all and (max-width: 576px) {
    width: 20%;
    min-height: 2.7em;
    border-width: 1px;
    margin: 0 0.3em 0.5em;
    max-width: 85px;
  }
`;

const DayRangeErrorMessage = styled.span`
  color: ${(p) => p.theme.color.error};
  display: block;
  width: 100%;
  position: relative;
  font-size: 0.8em;
  margin-top: 1em;  
  margin-bottom: -1em;
`;

export default {
  DayRangeErrorMessage,
  DayRangeButton,
  DayRangeWrapper,
};
